import React, {  useState, useEffect } from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import  { Button } from '../../globalStyle';
import { url } from '../../App';


const UseFaBars = styled(FaBars)`
    width:24px;
    height:24px;
`
const UseFaTimes = styled(FaTimes)`
    width:24px;
    height:24px;
`
const NavbarContainer = styled('div')`
    z-index:999999;
    width:100%;
    display:flex;
    height: 60px;
    overflow-x:visible;
    top:0;
    padding-right: 80px;
    padding-left: 80px;
    position:fixed;
    background: ${({ background }) => (background ? background : `transparent`)};
    box-shadow: ${({ shadow }) => (shadow ? shadow : '')};
    transition:.5s;
    justify-content:space-between;
    align-items: center;
    @media screen and (max-width: 800px) {
        padding-right: 20px;
        padding-left: 20px;
    }
    `;

const NavLogoTitle = styled(Link)`
    color: #000;
    font-size: 22px;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration:none;
    cursor:pointer;
    @media screen and (max-width: 800px) {
        font-size: 16px;
    }
`

const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    @media screen and (max-width: 800px) {
        flex-direction: column;
        width: 100%;
        z-index:99999999;
        height: 100vh;
        position: absolute;
        top: 60px;
        left: ${({ click }) => (click ? 0 : '-100%')};
        background: #101522;
        transition: all 0.5s ease;
    }
    `;

const NavItem = styled.li`

    &:hover {
    color: #f0f0f0;
    }
@media screen and (max-width: 800px) {
    width: 100%;
    background: #101522;
    z-index:999;
        &:hover {
            border: none;
        }
    }
    `;


const MobileIcon = styled.div`
    display: none;

@media screen and (max-width: 800px) {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    /* margin-right: 20px; */
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    z-index:99999;
    cursor: pointer;
    }
    `;

const NavItemBtn = styled.li`
    @media screen and (max-width: 800px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
    }
`;

const A = styled('a')`
    text-decoration:none;
    color: #fff;
    display: flex;
    font-size: 18px;
    font-weight:500;
    align-items: center;
    text-decoration: none;
    padding: 0.5rem 1rem;
    height: 100%;
    &:hover{
        color:#F9A826;
    }
    @media screen and (max-width: 800px) {
        text-align: center;
        padding: 2rem;
        width: 100%;
        display: table;
        font-size:16px;
    }
    `
    const Name = styled('p')`
        font-size:1em;
        color:#fff;
        letter-spacing: 2px;
        font-family: 'Poppins', sans-serif;
        font-weight:600;
    `
const Navbar = () => {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);
    const [navbar, setNavbar] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMenu = () => setClick(false);

    const showButton = () => {
        if(window.innerWidth <= 800){
            setButton(false);
        } else {
            setButton(true);
        }
    }
   
    useEffect(() => {
      showButton();
        return()=>{
            setClick(!click)
        }
    },[])

    window.addEventListener('resize', showButton);

    const ChangeBackground = () => {
        if(window.scrollY >= 1){
            setNavbar(true)
        }else{
            setNavbar(false)
        }
    }

    window.addEventListener('scroll', ChangeBackground);


    return(
        <>
        {/* <Nav> */}
            <NavbarContainer background={ navbar ? '#4a55da': '' } shadow={navbar ? '0px 1px 4px 1px rgba(0,0,0,0.2)' : ''}>
            <IconContext.Provider value={{color: '#fff'}}>
                        <NavLogoTitle to='/' onClick={closeMenu}><Name>Adam Dwi Maulana</Name></NavLogoTitle>
                        <MobileIcon onClick={handleClick}>
                            {click ? <UseFaTimes /> : <UseFaBars />}
                        </MobileIcon>
                    <NavMenu onClick={handleClick} click={click}>
                        <NavItem>
                            <A href="#projects" onClick={closeMenu}>
                                 Projects
                            </A>
                        </NavItem>
                        <NavItem>
                            <A href='#skill' onClick={closeMenu}>Skills</A>
                        </NavItem>
                        <NavItem>
                            <A href='#certificates' onClick={closeMenu}>Certificates</A>
                        </NavItem>
                        <NavItemBtn>
                            {button ? ( 
                                <a href="#"><Button> Download CV </Button></a>
                             )
                           :  
                            (
                                <a href="#"><Button  big fontbig>Download CV </Button></a>
                            )
                        }
                        </NavItemBtn>
                    </NavMenu>
            </IconContext.Provider>
            </NavbarContainer>
        {/* <Profile /> */}
   

    {/* </Nav> */}

        </>
    );
}

export default Navbar;